import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Marquee from "../components/Marquee";
import AutomotiveSection from "../components/AutomotiveSection";
import TechnologySection from "../components/TechnologySection";
import VideoSection from "../components/VideoSection";
import GallerySection from "../components/GallerySection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import { AUTO_HERO, AUTO_FILMS, LINKS } from "../mock/data";

export default function AutomotivePage() {
  return (
    <div className="App bg-[#0a0a0a] overflow-x-hidden">
      <Navbar />
      <PageHero
        image={AUTO_HERO}
        kicker="Automotive Lighting"
        title="CONQUER THE 4x4 NIGHT"
        subtitle="Race-proven LED light bars, pods and vehicle-specific kits for trucks, Jeeps, UTVs and overlanders."
        shopLink={LINKS.autoShop}
      />
      <Marquee />
      <AutomotiveSection />
      <TechnologySection />
      <VideoSection
        films={AUTO_FILMS}
        kicker="Automotive Films"
        title="INSTALLS & FIELD TESTS"
        subtitle="Watch real Baja Designs 4x4 installs and night output tests from the official channel."
      />
      <GallerySection />
      <CTASection />
      <Footer />
    </div>
  );
}
